// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hippowdon: PokeData = {
  "id": 450,
  "name": "hippowdon",
  "height": 20,
  "weight": 3000,
  "base_experience": 184,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "roar",
    "earthquake",
    "fissure",
    "dig",
    "rest",
    "sandstorm",
    "crunch",
    "yawn",
    "slack-off",
    "sand-tomb",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "bite",
    "earthquake",
    "fissure",
    "sandstorm",
    "crunch",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "bonemerang",
    "magnitude",
    "earth-power"
  ],
  "evolution_chain": {
    "id": 233,
    "item": null,
    "species": [
      {
        "name": "hippopotas",
        "order": 469,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hippowdon",
        "order": 470,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 449,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 156,
    "speed": 72,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
